<dbw-investor-viewer-accordion
  anchorId="investor-viewer-fiscalite"
  accordionTitle="Fiscalité"
  [itemsCount]="taxes().length">
  @if (taxes().length === 0) {
    <div class="empty-state">Aucune donnée de fiscalité disponible.</div>
  } @else {
    <div class="section-stack">
      @for (tax of taxes(); track $index) {
        <article class="tax-card dbw-card dbw-card--md">
          <header class="entity-header">
            <div>
              <h5>Année {{ formatText(tax.year) }}</h5>
              <p>
                Référence fiscale
                {{ formatCurrency(tax.referenceFiscalIncome) }}
              </p>
            </div>
            <strong class="entity-value">{{
              formatCurrency(tax.netIncomeTax)
            }}</strong>
          </header>

          <div class="section-stack">
            <section class="sub-card dbw-card dbw-card--md">
              <div class="subheading subheading--small">
                <h5>Impôt sur le revenu</h5>
              </div>
              <div class="detail-grid">
                <article class="detail-item dbw-card dbw-card--lg">
                  <span class="detail-item__label">Nombre de parts</span>
                  <strong>{{ formatNumber(tax.taxPartsCount) }}</strong>
                </article>
                <article class="detail-item dbw-card dbw-card--lg">
                  <span class="detail-item__label">Revenu imposable</span>
                  <strong>{{ formatCurrency(tax.taxableIncome) }}</strong>
                </article>
                <article class="detail-item dbw-card dbw-card--lg">
                  <span class="detail-item__label">TMI</span>
                  <strong>{{ formatPercentage(tax.incomeTaxBracket) }}</strong>
                </article>
                <article class="detail-item dbw-card dbw-card--lg">
                  <span class="detail-item__label">Impôt net</span>
                  <strong>{{ formatCurrency(tax.netIncomeTax) }}</strong>
                </article>
                <article class="detail-item dbw-card dbw-card--lg">
                  <span class="detail-item__label">Taux d'imposition</span>
                  <strong>{{ formatPercentage(tax.incomeTaxRate) }}</strong>
                </article>
                <article class="detail-item dbw-card dbw-card--lg">
                  <span class="detail-item__label">Plafond retraite inutilisé</span>
                  <strong>{{
                    formatCurrency(tax.unusedRetirementSavingsCeiling)
                  }}</strong>
                </article>
                <article class="detail-item dbw-card dbw-card--lg">
                  <span class="detail-item__label">Soumis au barème</span>
                  <strong>{{
                    formatCurrency(tax.incomeTaxSubjectToScale)
                  }}</strong>
                </article>
                <article class="detail-item dbw-card dbw-card--lg">
                  <span class="detail-item__label">Décote</span>
                  <strong>{{ formatCurrency(tax.discount) }}</strong>
                </article>
                <article class="detail-item dbw-card dbw-card--lg">
                  <span class="detail-item__label">Net avant corrections</span>
                  <strong>{{
                    formatCurrency(tax.netIncomeTaxBeforeCorrections)
                  }}</strong>
                </article>
                <article class="detail-item dbw-card dbw-card--lg">
                  <span class="detail-item__label">Réductions</span>
                  <strong>{{ formatCurrency(tax.totalTaxReductions) }}</strong>
                </article>
                <article class="detail-item dbw-card dbw-card--lg">
                  <span class="detail-item__label">Crédits d'impôt</span>
                  <strong>{{ formatCurrency(tax.totalTaxCredits) }}</strong>
                </article>
                <article class="detail-item dbw-card dbw-card--lg">
                  <span class="detail-item__label">
                    Revenu fiscal de référence
                  </span>
                  <strong>{{ formatCurrency(tax.referenceFiscalIncome) }}</strong>
                </article>
              </div>
            </section>

            <section class="sub-card dbw-card dbw-card--md">
              <div class="subheading subheading--small">
                <h5>Patrimoine et IFI</h5>
              </div>
              <div class="detail-grid">
                <article class="detail-item dbw-card dbw-card--lg">
                  <span class="detail-item__label">Tranche IFI</span>
                  <strong>{{ formatPercentage(tax.wealthTaxBracket) }}</strong>
                </article>
                <article class="detail-item dbw-card dbw-card--lg">
                  <span class="detail-item__label">IFI à payer</span>
                  <strong>{{ formatCurrency(tax.wealthTaxToPay) }}</strong>
                </article>
                <article class="detail-item dbw-card dbw-card--lg">
                  <span class="detail-item__label">Immobilier bâti</span>
                  <strong>{{ formatCurrency(tax.builtProperty) }}</strong>
                </article>
                <article class="detail-item dbw-card dbw-card--lg">
                  <span class="detail-item__label">Immobilier non bâti</span>
                  <strong>{{ formatCurrency(tax.unbuiltProperty) }}</strong>
                </article>
                <article class="detail-item dbw-card dbw-card--lg">
                  <span class="detail-item__label">Droits immobiliers</span>
                  <strong>{{ formatCurrency(tax.propertyRights) }}</strong>
                </article>
                <article class="detail-item dbw-card dbw-card--lg">
                  <span class="detail-item__label">Passif déductible</span>
                  <strong>{{ formatCurrency(tax.deductibleLiabilities) }}</strong>
                </article>
                <article class="detail-item dbw-card dbw-card--lg">
                  <span class="detail-item__label">Base imposable</span>
                  <strong>{{ formatCurrency(tax.taxableBase) }}</strong>
                </article>
                <article class="detail-item dbw-card dbw-card--lg">
                  <span class="detail-item__label">Réduction IFI</span>
                  <strong>{{ formatCurrency(tax.wealthTaxReduction) }}</strong>
                </article>
                <article class="detail-item dbw-card dbw-card--lg">
                  <span class="detail-item__label">Disponible fiscal</span>
                  <strong>{{ formatCurrency(tax.availableFiscalAmount) }}</strong>
                </article>
              </div>
            </section>

            <section class="sub-card dbw-card dbw-card--md">
              <div class="subheading subheading--small">
                <h5>Revenus et charges déductibles</h5>
              </div>
              <div class="detail-grid">
                <article class="detail-item dbw-card dbw-card--lg">
                  <span class="detail-item__label">Prélèvements sociaux</span>
                  <strong>{{
                    formatCurrency(tax.socialContributionsTotal)
                  }}</strong>
                </article>
                <article class="detail-item dbw-card dbw-card--lg">
                  <span class="detail-item__label">Salaires assimilés</span>
                  <strong>{{ formatCurrency(tax.totalSalaryIncome) }}</strong>
                </article>
                <article class="detail-item dbw-card dbw-card--lg">
                  <span class="detail-item__label">Revenu brut global</span>
                  <strong>{{ formatCurrency(tax.grossIncome) }}</strong>
                </article>
                <article class="detail-item dbw-card dbw-card--lg">
                  <span class="detail-item__label">
                    Déficit foncier reportable
                  </span>
                  <strong>{{
                    formatCurrency(tax.carryForwardPropertyDeficit)
                  }}</strong>
                </article>
                <article class="detail-item dbw-card dbw-card--lg">
                  <span class="detail-item__label">Charges déductibles</span>
                  <strong>{{ formatCurrency(tax.deductibleCharges) }}</strong>
                </article>
                <article class="detail-item dbw-card dbw-card--lg">
                  <span class="detail-item__label">CSG déductible</span>
                  <strong>{{ formatCurrency(tax.deductibleCsg) }}</strong>
                </article>
              </div>
            </section>

            @if (tax.notes?.trim()) {
              <div class="note-banner dbw-card dbw-card--md">
                <span class="identity-item__label">Note fiscale</span>
                <strong>{{ tax.notes }}</strong>
              </div>
            }

            @if (getTaxAdditionalFields(tax).length > 0) {
              <div class="mini-block">
                <div class="subheading subheading--small">
                  <h5>Champs complémentaires</h5>
                </div>
                <div class="mini-card-list">
                  @for (field of getTaxAdditionalFields(tax); track $index) {
                    <article class="mini-card dbw-card dbw-card--lg">
                      <span class="detail-item__label">{{ field.label }}</span>
                      <strong>{{ field.value }}</strong>
                    </article>
                  }
                </div>
              </div>
            }
          </div>
        </article>
      }
    </div>
  }
</dbw-investor-viewer-accordion>
